import CloseIcon from "components/Icons/CloseIcon";
import SearchIcon from "../Icons/SearchIcon";

const SearchInput = ({ handleSearch, search, setSearch }) => {
  return (
    <div className="border-3 flex rounded-full w-full">
      <form
        className="flex max-w-full w-full"
        onSubmit={(e) => e.preventDefault()}
      >
        <input
          onChange={handleSearch}
          id="vr-search-input"
          className="bg-transparent w-full py-2 px-3 text-black placeholder-black bg-transparent"
          type="text"
          placeholder="Etsi sivustolta"
        />
      </form>
      {search?.length > 0 ? (
        <button
          role="button"
          className="pr-5"
          onClick={() => {
            setSearch("");
          }}
        >
          <CloseIcon width={"15"} height={"15"}></CloseIcon>
        </button>
      ) : (
        <button role="button" disabled className="pr-5">
          <SearchIcon />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
